import { useMemo } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTheme } from '@mui/material/styles';
import { Verified, Close } from '@mui/icons-material';
import OtpInput from 'react-otp-input';

const TransactionOTPDialog = (props) => {
  const { showLoginOTPDialog, setShowLoginOTPDialog, otp, setOtp, verifyOTP, otpLoading } = props;

  const theme = useTheme();

  const buttonTheme = useMemo(() => {
    return {
      color: 'white', backgroundColor: theme.mainColor, fontSize: 15, fontWeight: "bold", borderRadius: 2,
      '&:hover': {
        backgroundColor: '#b30000', color: 'white', fontSize: 15, fontWeight: "bold", borderRadius: 2
      },
    }
  }, [theme.mainColor]);

  return (
    <Dialog open={showLoginOTPDialog}>
      <DialogTitle sx={{ fontSize: 23, mb: 2 }}>OTP Verification</DialogTitle>
      <DialogContent>
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '26px',
        }}>
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderInput={(props) => <input {...props} />}
            shouldAutoFocus
            inputStyle={{
              width: '1em', height: '1.5em', margin: '0 0.5em', fontSize: '2rem',
              textAlign: 'center', borderRadius: '8px', border: '1px solid #990000'
            }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => {
          setOtp('');
          setShowLoginOTPDialog(false);
        }}
          startIcon={<Close />} sx={{ mr: 1, color: theme.mainColor }}>Cancel</Button>
        <LoadingButton
          variant="contained"
          onClick={() => verifyOTP()}
          loadingPosition="start"
          startIcon={<Verified />}
          disabled={otp.length !== 6 || otpLoading}
          loading={otpLoading}
          sx={{ ...buttonTheme }}
        >
          {otpLoading ? "Verifying" : "Verify OTP"}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default TransactionOTPDialog;